import { getLocalLanguage, getTenantId } from '@/utils/index'
// 存储的key需要加上租户名，防止冲突，目前就TENANT和ACCESS_TOKEN不需要

const NOT_ADD_PRE_TENANT_ARR = ['ACCESS_TOKEN']
export const setLocalStorage = (key:string, obj = {}) => {
  var token = localStorage.getItem('ACCESS_TOKEN');  //获取token
  if (NOT_ADD_PRE_TENANT_ARR.includes(key) || !token) {
    localStorage.setItem(key, JSON.stringify(obj))
  } else {
    localStorage.setItem(getTenantId(token) + '_' + key, JSON.stringify(obj))
  }
}

export const getLocalStorage = (key: string) =>  {
  let obj = null
  var token = localStorage.getItem('ACCESS_TOKEN');  //获取token
  if (NOT_ADD_PRE_TENANT_ARR.includes(key) || !token) {
    obj = localStorage.getItem(key)
  } else {
    obj = localStorage.getItem(getTenantId(token) + '_' + key)
  }
  if (obj) {
    try {
      return JSON.parse(obj)
    } catch {
      return obj
    }
  } 
  return null
}

export const removeLocalStorage = (key: string) => {
  var token = localStorage.getItem('ACCESS_TOKEN');  //获取token
  if (NOT_ADD_PRE_TENANT_ARR.includes(key) || !token) {
    localStorage.removeItem(key)
  } else {
    localStorage.removeItem(getTenantId(token) + '_' + key)
  }
}

export const clearLocalStorage = (without) => {
  const items = {}
  for(let key of without) {
    if (key === 'lang') {
      items[key] = getLocalLanguage('')
    } else {
      items[key] = localStorage.getItem(key)
    }
  }
  localStorage.clear();
  Object.keys(items).forEach(key => {
    localStorage.setItem(key, items[key])
  })
}
